import { instance } from './index';

//계정목록 조회
function userList() {
  return instance.get('api/accounts');
}

//계정세부정보 조회
function detailUser(id) {
  return instance.get(`api/accounts/${id}`);
}

//계정 생성
function createUser(userData) {
  return instance.post('api/accounts', userData);
}

//해당계정의 정보 변경
function updateUser(id, userData) {
  return instance.put(`api/accounts/${id}`, userData);
}

export { createUser, detailUser, userList, updateUser };
